/**
 * Copyright Highway9 Networks Inc.
 */
import type { System } from "~/types/systemSetting";
import APIService from "./APIServices";

const systemSettingsAPI = new APIService<System>("system/settings");

export const systemSettingsService = {
  getAllSystemSettings,
  querySystemSettings,
  updateSystemSetting,
};

async function getAllSystemSettings(): Promise<System[]> {
  return querySystemSettings({});
}

async function querySystemSettings(payload: { name?: string } = {}): Promise<System[]> {
  try {
    const result = await systemSettingsAPI.postQuery("query", payload);
    return result?.data ?? [];
  } catch (error) {
    console.error(error);
    return [];
  }
}

async function updateSystemSetting(setting: System): Promise<void> {
  await systemSettingsAPI.update(setting, setting.id);
}